var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-wrap" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.formData },
        on: { Refresh: _vm.onHandleRefresh, search: _vm.onSearch },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.onHandleAdd },
                  },
                  [_vm._v("新增")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: !_vm.tableData.length || _vm.disabledExport,
                      type: "warning",
                      icon: "el-icon-download",
                    },
                    on: { click: _vm.onHandleExport },
                  },
                  [_vm._v("导 出")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  align: "center",
                  label: "城市仓名称",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                  fixed: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex a-center",
                            staticStyle: { "justify-content": "center" },
                          },
                          [
                            _vm._v(" " + _vm._s(scope.row.name || "-") + " "),
                            scope.row.location_address
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.location_address,
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-location-outline",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "regional_manager",
                  align: "center",
                  label: "区域经理",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                  fixed: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.regional_manager &&
                        scope.row.regional_manager.fullname
                          ? _c("div", { staticClass: "d-flex a-center" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.regional_manager.fullname || "-"
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  align: "center",
                  label: "集配中心",
                  width: "140",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (scope.row.business && scope.row.business.name) ||
                                "-"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  width: "80px",
                  align: "center",
                  label: "ID",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "province",
                  align: "center",
                  label: "省",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "city",
                  align: "center",
                  label: "市",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "county",
                  align: "center",
                  label: "区",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  align: "center",
                  label: "状态",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === _vm.DISABLED_ENUM.unDisabled.value
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("启用"),
                            ])
                          : _vm._e(),
                        scope.row.status === _vm.DISABLED_ENUM.disabled.value
                          ? _c("el-tag", { attrs: { type: "warning" } }, [
                              _vm._v("禁用"),
                            ])
                          : _vm._e(),
                        scope.row.status === _vm.DISABLED_ENUM.closed.value
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("已关仓"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_withdrawal",
                  align: "center",
                  label: "提现状态",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status !== _vm.DISABLED_ENUM.closed.value
                          ? _c(
                              "span",
                              {
                                staticClass: "text-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandleWithdrawal(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.withdrawalList.find(
                                      (item) =>
                                        item.value ===
                                        (scope.row.is_withdrawal ||
                                          _vm.IS_WITHDRAWAL.no.value)
                                    ).label
                                  )
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  align: "center",
                  label: "创建时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "100px",
                  prop: "delivery_number",
                  align: "center",
                  label: "启用自提点数量",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(scope.row.delivery_number) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_depart_report",
                  align: "center",
                  label: "车辆预提报",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "text-btn",
                            on: {
                              click: function ($event) {
                                return _vm.onHandleDepart(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Object.values(_vm.IS_DEPART_REPORT_ENUM).find(
                                    (item) =>
                                      scope.row.is_depart_report == item.value
                                  ).label
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "show_local_buy_region",
                  align: "center",
                  label: "显示地采专区",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "text-btn",
                            on: {
                              click: function ($event) {
                                return _vm.onHandleLocal(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Object.values(
                                    _vm.SHOW_LOCAL_BUY_REGION_ENUM
                                  ).find(
                                    (item) =>
                                      scope.row.show_local_buy_region ==
                                      item.value
                                  ).label
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "areas_name_txt",
                  align: "center",
                  label: "服务区域",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "certification_name",
                  align: "center",
                  label: "主体性质",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "certification_status_txt",
                  align: "center",
                  label: "认证状态",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "regional_user_num",
                  align: "center",
                  label: "区域总人口(万人)",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "coverage_user_num",
                  align: "center",
                  label: "仓覆盖人口(万人)",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  align: "center",
                  label: "开仓状态",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.is_enable == 0 ? "正常" : "停仓整改"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "earnest_money",
                  align: "center",
                  label: "保证金",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex a-center",
                            staticStyle: { "justify-content": "center" },
                            on: {
                              click: function ($event) {
                                return _vm.openAuth(scope.row)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-btn",
                                staticStyle: { "margin-right": "10px" },
                              },
                              [_vm._v(_vm._s(scope.row.earnest_money) + "元")]
                            ),
                            scope.row.earnest_status == 1
                              ? _c("img", {
                                  staticStyle: {
                                    width: "20px",
                                    height: "20px",
                                  },
                                  attrs: {
                                    src: require("@/assets/image/bao.png"),
                                    mode: "",
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_morning",
                  align: "center",
                  label: "开市时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.is_morning_change(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.is_morning == 0 ? "午市" : "早市"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_premiums_deduction",
                  align: "center",
                  label: "保险扣款",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.is_premiums_deduction == 0
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: `不扣款截止到 ${scope.row.premiums_deduction_deadline_date}截止；`,
                                  placement: "top-start",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.insurance(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v("否"),
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.insurance(scope.row)
                                  },
                                },
                              },
                              [_vm._v("是")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "virtual_account",
                  align: "center",
                  label: "开户状态",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.virtual_account ? "已开户" : "未开户"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "certification_status",
                  align: "center",
                  label: "绑卡状态",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.certification_status == 20
                                ? "已绑卡"
                                : "未绑卡"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  "min-width": "200",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandleEditData(
                                      scope.row,
                                      scope.row.status ==
                                        _vm.DISABLED_ENUM.closed.value
                                        ? "close"
                                        : ""
                                    )
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            scope.row.status !== _vm.DISABLED_ENUM.closed.value
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onHandleDisabled(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.status ===
                                          _vm.DISABLED_ENUM.unDisabled.value
                                          ? "禁用"
                                          : "启用"
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            scope.row.status !== _vm.DISABLED_ENUM.closed.value
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onHandleClose(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("关仓")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandleProhibited(scope.row)
                                  },
                                },
                              },
                              [_vm._v("禁售品类")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            scope.row.status !== _vm.DISABLED_ENUM.closed.value
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChangeCardholder(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("变更持卡人")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandleDeliverUrl(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看自提点")]
                            ),
                            scope.row.status !== _vm.DISABLED_ENUM.closed.value
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        scope.row.upgrade_position !=
                                        _vm.UPGRADE_POSITION_ENUM.upgrade.value,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onHandleAddDeliver(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("新增自提点")]
                                )
                              : _vm._e(),
                            scope.row.status !== _vm.DISABLED_ENUM.closed.value
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onHandleMove(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("迁移用户")]
                                )
                              : _vm._e(),
                            scope.row.certification_status < 10
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeOfSubjectclcik(
                                          scope.row,
                                          "主体认证"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("主体认证")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandleViewLog(scope.row)
                                  },
                                },
                              },
                              [_vm._v("操作日志")]
                            ),
                          ],
                          1
                        ),
                        _c("div"),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.formData.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("upgrade-store-dialog", {
        ref: "refUpgradeStore",
        attrs: { bankList: _vm.bankList },
        on: {
          "on-show-image": _vm.onHandleChangeData,
          "on-refresh-list": _vm.ajaxGetTableList,
        },
      }),
      _c("edit-store-dialog", {
        ref: "refEditStore",
        attrs: { logisticsList: _vm.logisticsList, bankList: _vm.bankList },
        on: {
          "on-show-image": _vm.onHandleChangeData,
          "on-refresh-list": _vm.ajaxGetTableList,
        },
      }),
      _c("edit-delivery-dialog", {
        ref: "refEditDelivery",
        attrs: { bankList: _vm.bankList },
        on: {
          "on-add-delivery": _vm.onHandleAddDelivery,
          "on-edit-delivery": _vm.onHandleDeliverDetail,
        },
      }),
      _c("delivery-list-dialog", {
        ref: "refDeliveryList",
        on: {
          "on-edit-delivery": _vm.onHandleEditDelivery,
          "on-edit-log": _vm.onHandleEditLog,
        },
      }),
      _c("product-supplement-dialog", {
        ref: "refProductSupplement",
        on: { "on-refresh-list": _vm.ajaxGetTableList },
      }),
      _c("delivery-edit-log-dialog", { ref: "refDeliveryEditLog" }),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showImage },
          on: {
            "update:visible": function ($event) {
              _vm.showImage = $event
            },
          },
        },
        [
          _c("img", {
            staticClass: "showImg",
            attrs: { src: _vm.bigImage, alt: "" },
          }),
        ]
      ),
      _c("move-user-dialog", {
        ref: "refMoveUserDialog",
        on: { "on-refresh-list": _vm.ajaxGetTableList },
      }),
      _c("prohibited-categories-dialog", {
        ref: "refProhibitedCategories",
        on: { "on-refresh-list": _vm.ajaxGetTableList },
      }),
      _c("sign-a-contract-dialog", {
        ref: "refSignContract",
        on: { "on-refresh-list": _vm.ajaxGetTableList },
      }),
      _c("insuranceDialog", {
        ref: "refinsuranceDialog",
        on: { insurance: _vm.ajaxGetTableList },
      }),
      _c("marginAuthenticationDialog", {
        ref: "marginAuthenticationRef",
        on: { "on-refresh-list": _vm.ajaxGetTableList },
      }),
      _c("changeCardholderDialog", {
        ref: "changeCardholderRef",
        attrs: { bankList: _vm.bankList },
        on: {
          "on-show-image": _vm.onHandleChangeData,
          "on-refresh-list": _vm.ajaxGetTableList,
        },
      }),
      _c("changeOfSubject", {
        ref: "changeOfSubjectRef",
        on: { "on-refresh-list": _vm.ajaxGetTableList },
      }),
      _c("cityLogDialog", { ref: "refcityLogDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }